var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShiftLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.25C1.58579 1.25 1.25 1.58579 1.25 2V22C1.25 22.4142 1.58579 22.75 2 22.75C2.41421 22.75 2.75 22.4142 2.75 22V2C2.75 1.58579 2.41421 1.25 2 1.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89637 7.44506C9.11604 7.24537 9.43281 7.19403 9.70429 7.31413C9.97578 7.43423 10.1509 7.70315 10.1509 8.00001V11.25H22.0005C22.4147 11.25 22.7505 11.5858 22.7505 12C22.7505 12.4142 22.4147 12.75 22.0005 12.75H10.1509V16C10.1509 16.2969 9.97578 16.5658 9.70429 16.6859C9.43281 16.806 9.11603 16.7547 8.89637 16.555L4.49637 12.555C4.34002 12.4128 4.25088 12.2113 4.25088 12C4.25088 11.7887 4.34002 11.5872 4.49637 11.4451L8.89637 7.44506Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiftLeft);
export default __webpack_public_path__ + "static/media/shift-left.b7042ef3ef4c3b28d7ed4c39364d083f.svg";
export { ForwardRef as ReactComponent };